module.exports = __webpack_public_path__ + "img/product.65d2cdea.png";